module.exports = __webpack_public_path__ + "static/media/8764.76a0d06d.png";